export const usesResource = (object, resource) =>
  (object.anchors || []).some((anchor) => {
    if (anchor.type !== resource.type) return false;
    if (
      resource.anchorId &&
      (anchor.id || anchor.objectId) === resource.anchorId
    )
      return true;
    if (!resource.identifier || !anchor.identifier) return false;
    // LifeCodes and BLE UUIDs are case-insensitive; ACRCloud IDs are opaque.
    const normalize = (value) =>
      resource.type === 'audio' ? String(value) : String(value).toUpperCase();
    return normalize(anchor.identifier) === normalize(resource.identifier);
  });
